/**
 * Created by heshufen on 19/3/18.
 */
import React from 'react'
// import {Dimensions, Text, View, div, Image} from 'react-native'
import {Horizontal, Vertical, Image, Text} from "../../../components/index";

import {merge}from '../../../utils/uiUtils'

const screenWidth = window.screen.width;

export default class StudyRecordView extends React.Component {

    state = {
        open: false
    }

    renderStudyBtn() {
        return (
            <Horizontal style={contentStyles.vCenter}>
                <Text style={contentStyles.studyTitle}>立即学习</Text>
                <Image style={styles.nextIcon} resizeMode="contain"
                       source={require('../assets/icon-next-orange.png')}/>
            </Horizontal>
        );
    }

    renderLearntBtn() {
        return (
            <Vertical style={merge(contentStyles.radiusBtn, contentStyles.green)}>
                <Text style={contentStyles.learnt}>已学习</Text>
            </Vertical>
        );
    }

    renderUnStudyBtn() {
        return (
            <Vertical style={merge(contentStyles.radiusBtn, contentStyles.gray)}>
                <Text style={contentStyles.unStudy}>未学习</Text>
            </Vertical>
        );
    }

    isNameApprove() {
        const {v = 0, annual} = this.props.ownerInfo;
        if (annual && annual.annual === 1) {
            return false;
        } else {
            return v === 1;
        }
    }

    _isSelf() {
        return false;
    }

    isPass() {
        return this.props.userInfo.healthExamination.level === 1;
    }

    isAllow() {
        const {allow = 0} = this.props.userInfo.healthExamination;
        return allow === 1;
    }

    goChapter = (index) => {
        if (this._isSelf()) {
            if (this.isAllow()) {
                this.props.navigation.push('Chapter', {
                    index,
                    canExam: !this.isPass()
                })
            } else {
                this.props.showNameApproveDialog(0)
            }
        }
    }

    renderItem(record, index) {
        let remainder = index % 2 === 0;
        return (
            <div key={index}>
                <Horizontal style={styles.itemContainer}>
                    <Text style={contentStyles.title}>{record.title}</Text>
                    {record.status === 1 ? this.renderLearntBtn() : (this._isSelf() ? this.renderStudyBtn() : this.renderUnStudyBtn())}
                </Horizontal>
                <Vertical style={{
                    height: 1,
                    backgroundColor: '#eee'
                }}/>
            </div>
        );
    }

    render() {
        let records = this.props.userInfo.healthExamination.chapter;

        if (!this.state.open) {
            records = records.slice(0, 2)
        }

        return (
            <Vertical style={{paddingBottom: 45,}}>
                <Horizontal style={styles.titleContainer}>
                    <Text style={styles.title}>纹身卫生学习记录
                        <Text style={styles.title2}>（大咖纹身守则）</Text></Text>
                </Horizontal>
                <Vertical style={styles.container}>
                    {records && records.map((record, index) => {
                    return this.renderItem(record, index);
                    })}
                    <div onClick={this._open}>
                        <Horizontal style={merge(styles.itemContainer, {
                            flex: 1,
                            borderBottomWidth: 0,
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: screenWidth - 30,
                        })}>
                            <Text style={{
                                flex: 1,
                                textAlign: 'center',
                                lineHeight: 49,
                                fontSize: 14,
                                color: '#404040'
                            }}>{this.state.open ? '收起' : '展开'}</Text>
                        </Horizontal>
                    </div>
                </Vertical>
            </Vertical>
        );
    }

    _open = () => {
        this.setState({open: !this.state.open})
    }
}

const contentStyles = {
    title: {
        flex: 1,
        marginLeft: 20,
        marginRight: 20,
        fontSize: 14,
        color: "#454545",
    },
    radiusBtn: {
        height: 20,
        marginRight: 20,
        borderRadius: 3,
        alignItems: 'center',
        justifyContent: 'center',
    },
    learnt: {
        fontSize: 14,
        color: "#22bb55"
    },
    green: {
        backgroundColor: "#f7f7f7",
    },
    studyTitle: {
        fontWeight: 'bold',
        fontSize: 13,
        color: "#ff7700"
    },
    vCenter: {
        alignItems: 'center'
    },
    gray: {
        backgroundColor: "#f7f7f7",
    },
    unStudy: {
        fontSize: 14,
        color: "#989898"
    },
}

const styles = {
    container: {
        marginLeft: 15,
        marginRight: 15,
        marginBottom: 15,
        borderRadius: 5,
        overflow: 'hidden',
        backgroundColor: "#F7F7F7",
    },
    titleContainer: {
        marginLeft: 15,
        marginTop: 20,
        marginBottom: 13,
        alignItems: 'center'
    },
    imageIcon: {
        width: 13,
        height: 13,
        marginRight: 10,
    },
    title: {
        fontSize: 16,
        color: "#232323"
    },
    title2: {
        fontSize: 13,
        color: "#999999"
    },
    line: {
        height: 1,
        backgroundColor: "#eeeeee"
    },
    itemContainer: {
        height: 49,
        alignItems: 'center',
        backgroundColor: "#f7f7f7",

    },
    nextIcon: {
        width: 6,
        height: 11,
        marginLeft: 5,
        marginRight: 20,
    },
};



// WEBPACK FOOTER //
// ./src/apps/portfolio/screens/StudyRecordView.js